import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { noCapMap } from '../../../../../utils';

const mapExternalCpdData = (externalCpdData, index) => {
  const {
    externalCpd: {
      userEmail,
      activityName,
      accreditationNumber,
      provider,
      modeOfLearning
    },
    cpdCategoryPoints,
    documentedPoints
  } = externalCpdData
  return <div key={index} className='top-gap'>
    <div>{`Email: ${userEmail}`}</div>
    <div>{`ActivityName: ${activityName}`}</div>
    <div>{`Accreditation Number: ${accreditationNumber}`}</div>
    <div>{`Provider: ${provider}`}</div>
    <div>{`Mode of Learning: ${modeOfLearning}`}</div>
    <div>{`Documented Points`}</div>
    <ul>
      {
        noCapMap(
          ({ name, points }) => <li key={name}>{`${name} - ${points}`}</li>
        )(documentedPoints)
      }
      {
        noCapMap(
          ({ cpdCategoryName, points }) => <li key={cpdCategoryName}>{`${cpdCategoryName} - ${points}`}</li>
        )(cpdCategoryPoints)
      }
    </ul>
  </div>
}

const AdminKaplanImportTaskData = ({ data }) => {
  const {
    externalCpds
  } = data
  return <div id='admin-kaplan-import-task-data'>
    {
      noCapMap(mapExternalCpdData)(externalCpds)
    }
  </div>
}

const mapStateToProps = ({ admin }) => ({
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidUpdate(prevProps) {
    }
  })
)(AdminKaplanImportTaskData)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/partials/admin-kaplan-import-task-data.js